// WebAuthn helpers — konversi base64url untuk browser API

export function base64UrlToBuffer(base64url) {
  const pad = '='.repeat((4 - (base64url.length % 4)) % 4);
  const b64 = (base64url + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  const buf = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) buf[i] = raw.charCodeAt(i);
  return buf.buffer;
}

export function bufferToBase64Url(buffer) {
  const bytes = new Uint8Array(buffer);
  let str = '';
  bytes.forEach((b) => { str += String.fromCharCode(b); });
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** Rekursif: ubah challenge & id (base64url) jadi ArrayBuffer untuk WebAuthn API */
export function preparePublicKeyOptions(publicKey) {
  if (!publicKey || typeof publicKey !== 'object') return publicKey;

  const pk = JSON.parse(JSON.stringify(publicKey));

  function walk(node) {
    if (Array.isArray(node)) {
      node.forEach(walk);
      return;
    }
    if (!node || typeof node !== 'object') return;

    for (const [key, val] of Object.entries(node)) {
      if ((key === 'challenge' || key === 'id') && typeof val === 'string') {
        node[key] = base64UrlToBuffer(val);
      } else if (typeof val === 'object') {
        walk(val);
      }
    }
  }

  walk(pk);
  return pk;
}

export function credentialToJson(credential) {
  const response = credential.response;
  return {
    id: credential.id,
    rawId: bufferToBase64Url(credential.rawId),
    type: credential.type,
    response: {
      clientDataJSON: bufferToBase64Url(response.clientDataJSON),
      attestationObject: response.attestationObject
        ? bufferToBase64Url(response.attestationObject) : undefined,
      authenticatorData: response.authenticatorData
        ? bufferToBase64Url(response.authenticatorData) : undefined,
      signature: response.signature
        ? bufferToBase64Url(response.signature) : undefined,
      userHandle: response.userHandle
        ? bufferToBase64Url(response.userHandle) : undefined,
    },
  };
}

export function passkeySupported() {
  return !!(window.PublicKeyCredential && navigator.credentials?.create);
}
